import { render, staticRenderFns } from "./indirizzoevento.vue?vue&type=template&id=315b6e78"
import script from "./indirizzoevento.vue?vue&type=script&lang=js"
export * from "./indirizzoevento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315b6e78')) {
      api.createRecord('315b6e78', component.options)
    } else {
      api.reload('315b6e78', component.options)
    }
    module.hot.accept("./indirizzoevento.vue?vue&type=template&id=315b6e78", function () {
      api.rerender('315b6e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/indirizzoevento.vue"
export default component.exports